<template>
  <v-select
    :clearable="false"
    :required="true"
    :loading="loading"
    :options="companyOptions"
    :reduce="option => option.value"
    :value="value"
    @input="setValue"
  />
</template>

<script>
import companiesApi from '@/api/companies'
import { mapSettings } from '@/utils/settings'

export default {
  props: {
    value: { type: String, default: null },
  },
  data: () => ({
    companies: [],
    loading: false,
  }),
  computed: {
    ...mapSettings(['companyUuid']),
    companyOptions() {
      return this.companies.map(({ name, uuid }) => ({ label: name, value: uuid }))
    },
  },
  methods: {
    async refreshSearch(searchText) {
      this.loading = true
      this.companies = await companiesApi.getFromSearch(searchText)
      this.loading = false
    },
    setValue(value) {
      if (value === this.companyUuid) return

      this.companyUuid = value
      this.$emit('input', value)
      window.location.href = '/'
    },
  },
  async mounted() {
    this.loading = true
    this.companies = await companiesApi.getAll()
    this.loading = false

    const initialSelectedCompany =
      this.companyOptions.find(({ value }) => value === this.companyUuid) || this.companyOptions[0]
    this.setValue(initialSelectedCompany?.value)
    this.$emit('input', initialSelectedCompany?.value)
  },
}
</script>

<style lang="scss" scoped>
* {
  min-width: 300px;
}
</style>
